import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Intro() {
  return (
    <section
      className="relative isolate flex min-h-[480px] items-center overflow-hidden md:min-h-[520px]"
      style={{ backgroundColor: '#0d0046' }}
      aria-labelledby="enterprise-software-intro-title"
    >
      <video
        className="absolute inset-0 -z-20 h-full w-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        disablePictureInPicture
        aria-hidden="true"
        src="https://res.cloudinary.com/djaejg3nn/video/upload/v1791178634/crm-erp-consulting-banner_d7iftm.mp4"
      />
      <div
        className="absolute inset-0 -z-10"
        style={{ backgroundColor: 'rgba(0, 22, 70, 0.7)' }}
        aria-hidden="true"
      />

      <div className="w-full px-[6.75vw] py-20 sm:py-24">
        <div className="w-full">
          <h1
            id="enterprise-software-intro-title"
            className="mb-6 max-w-[1200px] text-4xl font-semibold leading-tight tracking-tight text-white sm:text-5xl"
          >
            Rule The Digital-First World with Brilliant ERP and CRM Consulting Services
          </h1>
          <p className="mb-8 max-w-[1200px] text-white text-base font-normal leading-[27px]">
            Optimize operations, accelerate growth, streamline processes, and make data-driven decisions by implementing CRM and ERP systems. PT KCS helps businesses make the most of their enterprise software with consulting services tailored to their needs. Work with experienced ERP and CRM specialists to make a change.
          </p>
          <Link
            to="/contact"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-2 rounded-sm px-7 py-3 text-base font-bold text-white transition-colors hover:bg-sky-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            style={{ backgroundColor: '#0798f2' }}
          >
            Get ERP &amp; CRM Consulting Now
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
